import React from "react";
import { useDispatch } from "react-redux";

import { IgIconButton, IgTooltip, IgTypography } from "@intelligems/ig-theme";
import { ExperienceDto } from "@intelligems/ig-types";
import { SvgIcon } from "@mui/material";

import { AreYouSure } from "../../../../components/Popover/AreYouSure";
import { CustomLockIcon } from "../../../../images/Icons/ExperimentTable/CustomLockIcon";
import { PauseIcon } from "../../../../images/Icons/ExperimentTable/PauseIcon";
import { PlayIcon } from "../../../../images/Icons/ExperimentTable/PlayIcon";
import { StopIcon } from "../../../../images/Icons/ExperimentTable/StopIcon";
import { setDialog } from "../../../../store/slices/global";
import theme from "../../../../theme";

export interface ActionExperienceButtonProps {
  isLoading: boolean;
  disabled: boolean;
  onClick: (experience: ExperienceDto) => void;
  experience: ExperienceDto;
  action: "start" | "end" | "pause";
}

export const ActionExperienceButton = ({
  isLoading,
  disabled,
  onClick,
  experience,
  action,
}: ActionExperienceButtonProps) => {
  const dispatch = useDispatch();
  const onDisableClick = () => {
    dispatch(
      setDialog({ dialog: "billingStatus", open: true, props: experience })
    );
  };

  return (
    <IgTooltip
      title={
        disabled
          ? ""
          : action === "start"
            ? "Start"
            : action === "pause"
              ? "Pause"
              : ""
      }
    >
      <AreYouSure
        keyId={`end-exp-${experience.id}`}
        buttonText={"Yes"}
        enabled={action === "end"}
        isLoading={isLoading}
        message={
          <IgTypography>
            Are you sure you want to end this experiment?
          </IgTypography>
        }
        onYesClick={() => onClick(experience)}
      >
        {disabled ? (
          <IgIconButton
            size={"small"}
            loading={isLoading}
            onClick={() => {
              onDisableClick();
            }}
          >
            <CustomLockIcon />
          </IgIconButton>
        ) : (
          <IgIconButton
            size={"small"}
            loading={isLoading}
            disabled={disabled}
            onClick={() => {
              onClick(experience);
            }}
          >
            {action === "start" ? (
              <SvgIcon
                component={PlayIcon}
                inheritViewBox={true}
                sx={{
                  fill: "#909090",
                  stroke: "#909090",
                  "&:hover, &:focus": {
                    fill: theme.palette.primary.main,
                    stroke: theme.palette.primary.main,
                  },
                }}
              />
            ) : action === "pause" ? (
              <SvgIcon
                component={PauseIcon}
                inheritViewBox={true}
                sx={{
                  fill: "#909090",
                  stroke: "#909090",
                  "&:hover, &:focus": {
                    fill: theme.palette.primary.main,
                    stroke: theme.palette.primary.main,
                  },
                }}
              />
            ) : (
              <SvgIcon
                component={StopIcon}
                inheritViewBox={true}
                sx={{
                  fill: "#909090",
                  stroke: "#909090",
                  "&:hover, &:focus": {
                    fill: theme.palette.primary.main,
                    stroke: theme.palette.primary.main,
                  },
                }}
              />
            )}
          </IgIconButton>
        )}
      </AreYouSure>
    </IgTooltip>
  );
};
